export default function GeneralWorkspaceSettingsPane(props) {
    return <>
        <h2>General</h2>
        <p>There are no general settings for now.</p>
    </>;
}
